export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";
export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
export const MEMBER_UPDATED = "MEMBER_UPDATED";
export const SUBSCRIBER_METADATA_UPDATED = "SUBSCRIBER_METADATA_UPDATED";
export const IS_OPEN_LOGIN_FORM = "IS_OPEN_LOGIN_FORM";
export const CLOSE_SEARCHBAR= "CLOSE_SEARCHBAR";
export const AUTH_INITIALIZATION_STARTED = "AUTH_INITIALIZATION_STARTED";
export const AUTH_INITIALIZATION_COMPLETED = "AUTH_INITIALIZATION_COMPLETED";
export const MOBILE_MENU_TOGGLED = "MOBILE_MENU_TOGGLED";
